module.exports = __webpack_public_path__ + "static/media/Video_final.5acc6373.mp4";